<template>
    <div
            v-if="isLogin"
            class="member d-flex justify-space-between"
            v-resize="resizeHandler"
    >
        <div class="member__info d-flex align-center">
            <div class="member__info-svg d-flex justify-center align-center">
                <svg-icon name="lattice"/>
            </div>
            <div class="member__info-row">
                <div v-if="actualWidth >= 768" class="member__info-title" v-html="$t('members.member-dashboard.personal_passcode_title', {passCode: getClient.pass_code.code})"></div>
                <div v-else class="member__info-title"><b>{{getClient.pass_code.code}}</b></div>
                <div
                     v-if="actualWidth >= 768"
                     class="member__info-subtitle"
                >
                    {{$t('members.member-dashboard.personal_passcode_subtitle')}}
                </div>
            </div>
        </div>
        <div class="member__info d-flex align-center">
            <div class="member__info-svg d-flex justify-center align-center">
                <svg-icon name="dumbbell"/>
            </div>
            <div class="member__info-row">
                <div v-if="actualWidth >= 1024" class="member__info-title" v-html="$t('members.member-dashboard.passcode_still_days', { days: getClient.pass_code.days_remaining})"></div>
                <div v-else-if="actualWidth < 1024 && actualWidth > 768" class="member__info-title" v-html="$t('members.member-dashboard.passcode_still_days_tablet', { days: getClient.pass_code.days_remaining})"></div>
                <div v-else class="member__info-title">
                    <span v-html="$t('members.member-dashboard.passcode_still_days_mobile')"></span>
                    <b> {{getClient.pass_code.days_remaining}}</b>
                </div>

                <div
                    v-if="actualWidth >= 768"
                    class="member__info-subtitle">{{$t('members.member-dashboard.passcode_expiration_date', { date: getExpirationDate })}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import formatDateMixin from "@/mixins/formatDateMixin";
    import resizeMixin from "@/mixins/resize";

    export default {
        mixins: [formatDateMixin, resizeMixin],

        computed: {
            ...mapGetters([
                'getClient',
            ]),

            isLogin() {
                return Object.keys(this.getClient).length !== 0
            },

            getExpirationDate() {
                return this.formatDate(this.getClient.pass_code.expiration_at, true);
            },
        }
    }
</script>

<style lang="sass" scoped>
.member
    margin: -45px auto 0
    max-width: calc(100vw - 40px)
    width: 1250px
    background-color: $color--white
    box-shadow: 0 8px 16px rgba(11, 35, 75, 0.1)
    border-radius: 2px
    padding: 28px 40px

    +r(1276)
        flex-direction: column
        padding: 0

    &__info
        &-row
            width: 100%
            display: flex
            flex-direction: column

            +r(1276)
                text-align: center

            +r(767)
                text-align: left
                align-items: center
                justify-content: center
                flex-direction: row


        &-svg
            width: 34px
            height: 34px
            background-color: rgba(#0B234B, 0.06)
            border-radius: 2px
            margin-right: 12px

            +r(1276)
                position: relative
                width: 60px
                height: 60px

                &::after
                    content: ""
                    position: absolute
                    top: 50%
                    transform: translateY(-50%)
                    left: 100%
                    width: 0
                    height: 0
                    border-top: 30px solid transparent
                    border-bottom: 30px solid transparent
                    border-left: 15px solid rgba(#0B234B, 0.06)

        &-title
            +reg
            color: $color--dark
            font-size: 20px
            letter-spacing: 0.5px

            +r(599)
                +medium
                font-size: 14px
                position: absolute
                display: flex
                align-items: center
                justify-content: center

                b
                    margin-left: 5px
                    font-size: 24px


        &-subtitle
            +reg
            font-size: 14px
            letter-spacing: 0.5px
            color: $color--dark
            opacity: 0.6
</style>